import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addVideo} from "../../actions/videoAction";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';

import 'react-toastify/dist/ReactToastify.css';

class VideoAddModel extends React.Component {

    constructor() {
        super();
        this.state = {
            name: "",
            short_name:"",
            order_sequence:"",
            errors: {},
            coinImage: '',
            is_deposit:0,
            is_withdrawal:0,
            is_trade:0,
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.errors) {
            this.setState({
                errors: nextProps.errors
            });
        }
       
    }
    handleChange = (event) => {
        let { name, value } = event.target;
        console.log("valuefdvfdv",event.target)
        this.setState({ [name]: value, emptyField: false, errMsg: "" });
      };

    onChange = e => {

        // if (e.target.name === 'currencyVideo') {
        //     var currencyVideo = e.target.files[0];
            
        //     var fileSize = e.target.files[0].size;
        //     if (fileSize > 1000000) {
        //         this.setState({ invalidImage: "Maximum 1 MB Image allowed.", userUploadImage: false });
        //         return false;
        //     }
        //     console.log(this.state.invalidImage);
        //     if (!currencyVideo.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        //         this.setState({ invalidImage: "Please select valid image jpeg,png,gif.", userUploadImage: false });
        //         return false;
        //     }
        
        //     this.setState({
        //         coinImage: currencyVideo,
        //     });
        // }

        this.setState({ [e.target.id]: e.target.value });
    };

    onCryptoAdd = e => {
        e.preventDefault();
        console.log("YTest",this.state.name,this.state.currencyVideo)
        
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        
        var formData = {
            "name":this.state.name,
            "currencyVideo":this.state.currencyVideo
        }
        console.log("formdata",formData)
        this.props.addVideo(formData,config);
    };

    render() {
        const { errors } = this.state;
        return (
            <div>
                <div className="modal fade" id="add-user-modal" data-reset="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Video Add Model</h4>
                                <button type="button" className="close" data-dismiss="modal">&times;</button>
                            </div>
                            <div className="modal-body">
                                <form noValidate onSubmit={this.onCryptoAdd} id="add-user">
                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="name">Video Heading</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.name}
                                                id="name"
                                                name="name"
                                                type="text"
                                                error={errors.name}
                                                className={classnames("form-control", {
                                                    invalid: errors.name
                                                })}/>
                                            <span className="text-danger">{errors.name}</span>
                                        </div>
                                    </div>

                                    
                                    <div className="row mt-2">
                                        <div className="col-md-3">
                                            <label htmlFor="name">Video</label>
                                        </div>
                                        <div className="col-md-9">
                                            <input
                                                onChange={this.onChange}
                                                value={this.state.currencyVideo}
                                                id="currencyVideo"
                                                name="currencyVideo"
                                                type="text"
                                                error={errors.currencyVideo}
                                                className={classnames("form-control", {
                                                    invalid: errors.currencyVideo
                                                })}/>
                                                
                                            <span className="text-danger">{errors.currencyVideo}</span>
                                        </div>
                                    </div>



                                   
                                </form>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
                                <button
                                    form="add-user"
                                    type="submit"
                                    className="btn btn-primary">
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

VideoAddModel.propTypes = {
    addVideo: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    errors: state.errors
});

export default connect(
    mapStateToProps,
    { addVideo }

)(withRouter(VideoAddModel));